import { ScrollArea } from "@/components/ui/ScrollArea";

function VerticalScrollArea({
  children,
  type = "auto",
}: {
  children: React.ReactNode;
  type?: "scroll" | "auto" | "hover";
}) {
  return (
    <ScrollArea
      css={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        width: "100%",
        backgroundColor: "white",
        overflowY: "auto",
      }}
      type={type}
      scrollHideDelay={1000}
    >
      {children}
    </ScrollArea>
  );
}

export default VerticalScrollArea;
